export default function importAll(r) {
  const files = {};

  for (const key of Object.keys(r)) {
    const filename = key.split('/').pop();
    const name = filename.replace('.svg', '').replace('.png', '');
    // the public directory is a lie
    files[name] = key.replace('/public', '');
  }

  return files;
}
